import { linkReplace } from '@loomhq/loom-embed';
import $ from 'jquery';
import _last from 'lodash/last';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateAddReplyId, updateExpandedReplyIds } from 'actions/comments';
import {
  COMMENT_CONTAINER_CLASS,
  COMMENT_REPLY_CONTAINER_SELECTOR,
  INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY,
  INLINE_COMMENT_LOOM_VIDEO_SELECTOR,
  VIDEO_TIMESTAMP_CLASS,
} from 'constants/comments';
import { deleteCommentCreator } from 'creators/comments';
import { getCloudfrontURI } from 'utilities/avatar';
import {
  calculateInlineEmbedDimensions,
  getFormattedDateForHeader,
  playVideoAtTimestamp,
  sanitizeContent,
  updateAllEmbedWidths,
  userCanDelete,
} from 'utilities/comments';
import { secondsToVideoTS } from 'utilities/time';

import avatarPlaceholder from 'img/icons/comments-avatar-placeholder.svg';

import AddReply from '../add-reply';
import Reply from '../comment-reply';

import './styles.less';

const Comment = class extends Component {
  state = {
    scroll_to_add_reply: false,
  };

  onCommentContentClick = ev => {
    // This is for timestamps found in the comments.
    // Since comments are injected html they do not have the
    // method handleClickTimestamp attached.
    // Instead we catch this event as it bubbles up
    if (ev.target.className === VIDEO_TIMESTAMP_CLASS) {
      this.handleClickTimestamp(ev);
    }
  };

  render() {
    const {
      addReplyId,
      comment,
      commentsEnabled,
      commentList,
      companyFeatureData,
      currentUserIsOwner,
      user,
    } = this.props;

    const replies =
      comment.replies &&
      comment.replies.map(reply => {
        return <Reply key={reply.id} reply={reply} />;
      });

    let avatar = comment.avatar && comment.avatar.thumb;

    if (avatar) {
      avatar = getCloudfrontURI(avatar);
    } else {
      avatar = avatarPlaceholder;
    }

    const { brand_primary_color: brandColor } = companyFeatureData || {};
    const brandStyle =
      brandColor && !currentUserIsOwner ? { color: brandColor } : null;

    return (
      <div>
        <div className="post-container" id={`comment-${comment.id}`}>
          <img src={avatar} className="comment-avatar" />
          <div className="comment-post" data-seconds={comment.time_stamp}>
            <div className="comment-header">
              <div className="user-name"> {comment.user_name} </div>
              <div className="timestamp">
                <a
                  href="#"
                  className={VIDEO_TIMESTAMP_CLASS}
                  style={brandStyle}
                  onClick={this.handleClickTimestamp}
                  data-seconds={comment.time_stamp}
                >
                  {secondsToVideoTS(comment.time_stamp)}
                </a>
              </div>
            </div>
            <div
              className={COMMENT_CONTAINER_CLASS}
              dangerouslySetInnerHTML={{ __html: sanitizeContent(comment) }}
              onClick={this.onCommentContentClick}
            />
            {commentsEnabled && (
              <div className={'actions-section'}>
                <div className="right">
                  {userCanDelete(comment, currentUserIsOwner, user) && (
                    <span
                      className="delete"
                      style={brandStyle}
                      onClick={this.deleteComment}
                    >
                      Delete
                    </span>
                  )}
                  <span
                    className="show-add-reply"
                    style={brandStyle}
                    onClick={this.showAddReply}
                  >
                    Reply
                  </span>
                  <span className="date-section">
                    {getFormattedDateForHeader(comment.createdAt)}
                  </span>
                </div>
              </div>
            )}
            {commentsEnabled && replies && replies.length > 0 && <hr />}
            {commentsEnabled && replies}
            {commentsEnabled && addReplyId === comment.id && (
              <AddReply
                comment={comment}
                brandColor={currentUserIsOwner ? null : brandColor}
              />
            )}
          </div>
        </div>
        {commentList.length > 1 && _last(commentList).id !== comment.id && (
          <hr />
        )}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    const { scroll_to_add_reply: shouldScroll } = this.state;

    const { comment } = this.props;
    const { comment: prevComment } = prevProps;

    if ((prevComment.replies || []).length !== (comment.replies || []).length) {
      const commentContainer = document.querySelector(
        COMMENT_REPLY_CONTAINER_SELECTOR
      );

      linkReplace &&
        commentContainer &&
        linkReplace(
          INLINE_COMMENT_LOOM_VIDEO_SELECTOR,
          calculateInlineEmbedDimensions(commentContainer.offsetWidth)
        );

      // we add this delay to make sure that the iframe has loaded and
      // there's actually something to resize
      window.setTimeout(
        updateAllEmbedWidths,
        INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY
      );
    }

    if (!shouldScroll) {
      return;
    }

    const $commentsContainer = $('.container-comments');
    const $addReplyBox = $('.add-reply-content');

    if (!$addReplyBox[0]) {
      return;
    }

    // we adjust it back by 45px so it looks better by showing some of the
    // comments above
    $commentsContainer.animate(
      {
        scrollTop:
          $commentsContainer.scrollTop() -
          $commentsContainer.offset().top +
          $addReplyBox.offset().top -
          45,
      },
      1000
    );

    $addReplyBox[0].focus();

    this.setState({ scroll_to_add_reply: false });
  }

  handleClickTimestamp = event => {
    document.body.scrollTo(0, 0);
    playVideoAtTimestamp.call(event.target, event);
  };

  deleteComment = () => {
    const { comment } = this.props;

    if (window.confirm('Are you sure you want to delete this comment?')) {
      this.props.deleteComment(comment.id);
    }
  };

  showAddReply = () => {
    const { comment } = this.props;

    this.setState({ scroll_to_add_reply: true });

    this.props.updateAddReplyId(comment.id);
  };

  showReplies = () => {
    const { comment, expandedIds } = this.props;

    this.props.updateExpandedReplyIds(expandedIds.concat(comment.id));
  };
};

const mapStateToProps = state => {
  const { comments, share_video, user } = state;
  const { add_reply_id: addReplyId, comments: commentList } = comments;

  const { current_user_is_owner: currentUserIsOwner, video } = share_video;
  const {
    comments_enabled: commentsEnabled,
    company_feature_data: companyFeatureData,
  } = video;

  return {
    addReplyId,
    commentsEnabled,
    commentList,
    companyFeatureData,
    currentUserIsOwner,
    user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteComment: id => dispatch(deleteCommentCreator(id)),
    updateAddReplyId: id => dispatch(updateAddReplyId(id)),
    updateExpandedReplyIds: expandedIds =>
      dispatch(updateExpandedReplyIds(expandedIds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comment);
